// Beauty & Salon Surgical Instruments

export const productCategories = [
  {
    id: 'salon-professional',
    name: 'Professional Salon Instruments',
    description: 'Premium scissors, razors, and cutting tools for professional stylists',
    image: 'https://images.unsplash.com/photo-1560066984-138dadb4c035?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQ4Njh8MHwxfHNlYXJjaHwxfHxoYWlyJTIwc2Fsb258ZW58MHx8fHwxNzM0NTY5NzQwfDA&ixlib=rb-4.0.3&q=85',
    icon: 'Scissors',
    productCount: 45
  },
  {
    id: 'barbershop-essentials',
    name: 'Barbershop Essentials',
    description: 'Classic shaving kits, razors, and grooming tools in gold & chrome finish',
    image: 'https://images.unsplash.com/photo-1503951914875-452162b0f3f1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQ4Njh8MHwxfHNlYXJjaHwyfHxiYXJiZXJzaG9wfGVufDB8fHx8MTczNDU2OTc0MHww&ixlib=rb-4.0.3&q=85',
    icon: 'Razor',
    productCount: 38
  },
  {
    id: 'manicure-pedicure',
    name: 'Manicure & Pedicure Tools',
    description: 'Complete nail care instruments and beauty surgical tools',
    image: 'https://images.unsplash.com/photo-1604654894610-df63bc536371?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQ4Njh8MHwxfHNlYXJjaHwzfHxtYW5pY3VyZXxlbnwwfHx8fDE3MzQ1Njk3NDB8MA&ixlib=rb-4.0.3&q=85',
    icon: 'Sparkles',
    productCount: 42
  }
];

export const products = [
  // ========== SALON PROFESSIONAL CATEGORY ==========
  {
    id: 1,
    name: "Professional Hair Cutting Scissors - Gold Series",
    category: "salon-professional",
    price: 249.99,
    originalPrice: 349.99,
    currency: "USD",
    inStock: true,
    description: "Premium Japanese steel hair cutting scissors with 24K gold plated handles. Perfect balance and razor-sharp precision for professional stylists.",
    longDescription: "Experience the ultimate in professional hair cutting with our Gold Series scissors. Handcrafted from premium Japanese 440C stainless steel and finished with luxurious 24K gold plating, these scissors represent the pinnacle of beauty instrument craftsmanship. The convex edge is hand-sharpened to perfection, ensuring effortless cutting through all hair types. Ergonomically designed with an offset handle to reduce hand fatigue during long styling sessions.",
    specifications: [
      "Blade Length: 5.5\", 6\", 6.5\"",
      "Material: Japanese 440C stainless steel",
      "Finish: 24K Gold plated handles",
      "Edge: Convex edge, hand-sharpened",
      "Tension: Adjustable screw system",
      "Weight: 45g (5.5\"), 52g (6\"), 58g (6.5\")",
      "Hardness: 58-60 HRC"
    ],
    features: [
      "Ultra-sharp convex edge for precision cutting",
      "Ergonomic offset design reduces strain",
      "24K Gold plated luxury finish",
      "Professional salon grade quality",
      "Lifetime sharpening service available",
      "Includes luxury storage case"
    ],
    image: "https://images.unsplash.com/photo-1560066984-138dadb4c035?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQ4Njh8MHwxfHNlYXJjaHwxfHxoYWlyJTIwc2Fsb258ZW58MHx8fHwxNzM0NTY5NzQwfDA&ixlib=rb-4.0.3&q=85",
    featured: true,
    rating: 4.9,
    reviews: 127,
    certifications: ["ISO 9001", "CE Marked"]
  },
  {
    id: 2,
    name: "Texturizing Shears - Chrome Elite",
    category: "salon-professional",
    price: 189.99,
    originalPrice: 259.99,
    currency: "USD",
    inStock: true,
    description: "Professional texturizing scissors with chrome finish. 25-30 teeth for perfect blending and thinning.",
    longDescription: "Master the art of hair texturizing with our Chrome Elite shears. Featuring 25-30 precision-cut teeth, these shears are designed for seamless blending and natural thinning. The mirror chrome finish not only looks stunning but also provides superior durability and easy cleaning. Ideal for creating soft, natural layers and removing bulk without compromising hair health.",
    specifications: [
      "Length: 6 inches",
      "Teeth: 25-30 teeth design",
      "Material: German stainless steel",
      "Finish: Mirror chrome plated",
      "Handle: Ergonomic crane design",
      "Thinning rate: 30-35%"
    ],
    features: [
      "Smooth texturizing action",
      "Chrome mirror finish for durability",
      "Lightweight design prevents fatigue",
      "Professional thinning results",
      "Easy to clean and maintain"
    ],
    image: "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQ4Njh8MHwxfHNlYXJjaHw1fHxoYWlyJTIwc2Fsb258ZW58MHx8fHwxNzM0NTY5NzQwfDA&ixlib=rb-4.0.3&q=85",
    featured: true,
    rating: 4.8,
    reviews: 89,
    certifications: ["ISO 9001", "CE Marked"]
  },
  {
    id: 3,
    name: "Barber Razor Scissors Combo Set",
    category: "salon-professional",
    price: 399.99,
    originalPrice: 549.99,
    currency: "USD",
    inStock: true,
    description: "Complete professional cutting set with scissors, thinning shears, and styling comb in luxury gold case.",
    longDescription: "The ultimate professional kit for discerning stylists. This comprehensive set includes premium cutting scissors, precision thinning shears, a professional carbon fiber comb, and a luxurious leather presentation case. Perfect for professionals or as a prestigious gift. Each piece is crafted from Japanese steel and finished with gold accents for a truly luxurious experience.",
    specifications: [
      "Set includes: Cutting scissors (6\"), Thinning shears (6\"), Carbon fiber comb, Leather case",
      "Material: Japanese steel",
      "Finish: Gold & Chrome combination",
      "Case: Premium genuine leather",
      "Sizes: 5.5\" and 6\" options"
    ],
    features: [
      "Complete professional kit",
      "Luxury leather presentation case",
      "Gold plated accents throughout",
      "Perfect for gifting",
      "Matching design across all pieces"
    ],
    image: "https://images.unsplash.com/photo-1585747860715-2ba37e788b70?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQ4Njh8MHwxfHNlYXJjaHw3fHxoYWlyJTIwc2Fsb258ZW58MHx8fHwxNzM0NTY5NzQwfDA&ixlib=rb-4.0.3&q=85",
    featured: true,
    rating: 5.0,
    reviews: 64,
    certifications: ["ISO 9001", "CE Marked"]
  },
  {
    id: 4,
    name: "Professional Hair Razor with Changeable Blades",
    category: "salon-professional",
    price: 79.99,
    originalPrice: 119.99,
    currency: "USD",
    inStock: true,
    description: "Precision hair razor for detailed work, texturizing, and shaping. Chrome finish with replaceable blades.",
    longDescription: "Achieve razor-sharp precision with this professional hair razor. Perfect for creating texture, removing weight, and detailed shaping work. The chrome-plated brass handle provides excellent balance and control, while the changeable blade system ensures you always have a sharp edge. Includes 10 replacement blades to get you started.",
    specifications: [
      "Type: Straight edge razor",
      "Blade: Changeable single-edge",
      "Handle: Chrome plated brass",
      "Length: 6 inches closed, 11 inches open",
      "Includes: 10 replacement blades",
      "Blade width: 1.5 inches"
    ],
    features: [
      "Precision cutting and texturizing",
      "Replaceable blade system",
      "Professional chrome finish",
      "Balanced weight distribution",
      "10 blades included"
    ],
    image: "https://images.unsplash.com/photo-1599351431202-1e0f0137899a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQ4Njh8MHwxfHNlYXJjaHw5fHxiYXJiZXJ8ZW58MHx8fHwxNzM0NTY5NzQwfDA&ixlib=rb-4.0.3&q=85",
    featured: false,
    rating: 4.7,
    reviews: 112,
    certifications: ["ISO 9001", "CE Marked"]
  },

  // ========== BARBERSHOP ESSENTIALS CATEGORY ==========
  {
    id: 101,
    name: "Classic Straight Razor - Gold Damascus Edition",
    category: "barbershop-essentials",
    price: 449.99,
    originalPrice: 649.99,
    currency: "USD",
    inStock: true,
    description: "Luxury straight razor with Damascus steel blade and 24K gold plated handle. The ultimate traditional shaving experience.",
    longDescription: "Experience the pinnacle of traditional shaving with our Gold Damascus Edition straight razor. The blade features authentic Damascus steel with its characteristic layered pattern, providing exceptional sharpness and edge retention. The handle is crafted from solid brass and finished with 24K gold plating. Each razor comes in a handcrafted wooden presentation box, making it an heirloom-quality piece that will last generations.",
    specifications: [
      "Blade: Damascus steel pattern",
      "Handle: 24K gold plated brass",
      "Blade width: 5/8 inch",
      "Edge: Hollow ground",
      "Includes: Luxury wooden box, leather strop",
      "Weight: 95g",
      "Blade hardness: 60-62 HRC"
    ],
    features: [
      "Authentic Damascus steel beauty",
      "24K gold plated handle",
      "Professional barber quality",
      "Handcrafted wooden presentation box",
      "Leather strop included",
      "Heirloom quality craftsmanship"
    ],
    image: "https://images.unsplash.com/photo-1503951914875-452162b0f3f1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQ4Njh8MHwxfHNlYXJjaHwyfHxiYXJiZXJzaG9wfGVufDB8fHx8MTczNDU2OTc0MHww&ixlib=rb-4.0.3&q=85",
    featured: true,
    rating: 4.9,
    reviews: 78,
    certifications: ["ISO 9001", "CE Marked"]
  },
  {
    id: 102,
    name: "Professional Shaving Kit - Chrome Elite Set",
    category: "barbershop-essentials",
    price: 299.99,
    originalPrice: 429.99,
    currency: "USD",
    inStock: true,
    description: "Complete 7-piece chrome shaving set including razor, brush, bowl, stand, and grooming tools.",
    longDescription: "Transform your daily shaving routine into a luxury ritual with our Chrome Elite 7-piece set. This comprehensive kit includes everything needed for the perfect wet shave: a premium safety razor, genuine badger hair brush, chrome shaving bowl, elegant display stand, and precision grooming scissors and comb. Each piece features stunning mirror chrome finish and comes displayed on a beautiful chrome stand.",
    specifications: [
      "Set: 7 pieces complete",
      "Razor: Chrome safety razor",
      "Brush: Pure badger hair bristles",
      "Bowl: Chrome shaving bowl (4\" diameter)",
      "Stand: Premium chrome display stand",
      "Tools: Professional scissors (4.5\"), fine-tooth comb",
      "Dimensions: Stand 8\"H x 6\"W"
    ],
    features: [
      "Complete luxury shaving experience",
      "Mirror chrome finish throughout",
      "Professional barbershop quality",
      "Elegant display stand included",
      "Pure badger hair brush",
      "Perfect for traditional wet shaving"
    ],
    image: "https://images.unsplash.com/photo-1621605815971-fbc98d665033?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQ4Njh8MHwxfHNlYXJjaHw0fHxzaGF2aW5nfGVufDB8fHx8MTczNDU2OTc0MHww&ixlib=rb-4.0.3&q=85",
    featured: true,
    rating: 5.0,
    reviews: 94,
    certifications: ["ISO 9001", "CE Marked"]
  },
  {
    id: 103,
    name: "Beard Trimming Scissors - Gold Titanium",
    category: "barbershop-essentials",
    price: 89.99,
    originalPrice: 129.99,
    currency: "USD",
    inStock: true,
    description: "Precision beard and mustache scissors with gold titanium coating. Small, sharp, and perfectly balanced.",
    longDescription: "Master the art of beard grooming with these precision-crafted scissors. The gold titanium coating not only looks luxurious but also provides superior durability and corrosion resistance. Micro-serrated blades grip hair perfectly for precise cuts without slipping. The compact 4.5\" size offers exceptional control for detailed work on beards, mustaches, and eyebrows.",
    specifications: [
      "Length: 4.5 inches",
      "Material: Titanium coated steel",
      "Finish: Gold titanium coating",
      "Blade: Micro-serrated for grip",
      "Tips: Extra sharp pointed tips",
      "Weight: 28g"
    ],
    features: [
      "Perfect for detailed grooming",
      "Gold titanium coating",
      "Ultra-sharp pointed tips",
      "Comfortable grip rings",
      "Ideal for beard, mustache, eyebrows"
    ],
    image: "https://images.unsplash.com/photo-1599351431202-1e0f0137899a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQ4Njh8MHwxfHNlYXJjaHw2fHxiYXJiZXJ8ZW58MHx8fHwxNzM0NTY5NzQwfDA&ixlib=rb-4.0.3&q=85",
    featured: false,
    rating: 4.8,
    reviews: 156,
    certifications: ["ISO 9001", "CE Marked"]
  },
  {
    id: 104,
    name: "Professional Barber Comb Set - Gold & Black",
    category: "barbershop-essentials",
    price: 69.99,
    originalPrice: 99.99,
    currency: "USD",
    inStock: true,
    description: "Premium carbon fiber combs with gold accents. Heat resistant and anti-static for professional styling.",
    longDescription: "Upgrade your styling tools with this professional 6-piece carbon fiber comb set. Each comb features a gold-plated spine for added luxury and durability. The carbon fiber construction is heat resistant up to 450°F, making them perfect for use with blow dryers and hot tools. Anti-static properties prevent flyaways for smooth, professional results.",
    specifications: [
      "Set of 6 combs",
      "Material: Carbon fiber",
      "Accents: Gold plated spine",
      "Sizes: 6\", 7\", 8\", 9\"  plus 2 specialty combs",
      "Features: Heat resistant to 450°F, anti-static",
      "Teeth: Fine and wide combinations"
    ],
    features: [
      "Professional carbon fiber construction",
      "Gold luxury accents",
      "Heat resistant to 450°F",
      "Anti-static properties",
      "Complete size range for all styles"
    ],
    image: "https://images.unsplash.com/photo-1605497788044-5a32c7078486?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQ4Njh8MHwxfHNlYXJjaHw4fHxiYXJiZXJ8ZW58MHx8fHwxNzM0NTY5NzQwfDA&ixlib=rb-4.0.3&q=85",
    featured: false,
    rating: 4.7,
    reviews: 203,
    certifications: ["ISO 9001", "CE Marked"]
  },

  // ========== MANICURE & PEDICURE CATEGORY ==========
  {
    id: 201,
    name: "Professional Manicure Set - Rose Gold Collection",
    category: "manicure-pedicure",
    price: 179.99,
    originalPrice: 249.99,
    currency: "USD",
    inStock: true,
    description: "Luxury 15-piece rose gold plated manicure and pedicure set in premium leather case. Perfect for nail salons and spas.",
    longDescription: "Elevate your nail care to luxury status with our comprehensive 15-piece Rose Gold Collection. Each instrument is crafted from surgical-grade stainless steel and finished with beautiful rose gold plating. The set includes everything needed for professional manicures and pedicures: cuticle nippers, pushers, nail files, scissors, and more. Presented in a genuine leather case with individual slots for each tool.",
    specifications: [
      "Set: 15 premium instruments",
      "Finish: Rose gold plated",
      "Case: Genuine leather with satin lining",
      "Includes: Nippers (2), files (3), pushers (2), scissors (2), clippers (2), tweezers, cuticle knife, nail cleaner, buffer",
      "Material: Surgical grade stainless steel",
      "Case dimensions: 8\" x 5\" x 1.5\""
    ],
    features: [
      "Rose gold luxury finish",
      "Professional salon quality",
      "Complete 15-piece nail care set",
      "Premium genuine leather case",
      "Surgical grade stainless steel",
      "Perfect for professionals or luxury home use"
    ],
    image: "https://images.unsplash.com/photo-1604654894610-df63bc536371?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQ4Njh8MHwxfHNlYXJjaHwzfHxtYW5pY3VyZXxlbnwwfHx8fDE3MzQ1Njk3NDB8MA&ixlib=rb-4.0.3&q=85",
    featured: true,
    rating: 4.9,
    reviews: 287,
    certifications: ["ISO 9001", "CE Marked"]
  },
  {
    id: 202,
    name: "Cuticle Nipper - Gold Plated Professional",
    category: "manicure-pedicure",
    price: 59.99,
    originalPrice: 89.99,
    currency: "USD",
    inStock: true,
    description: "Precision cuticle nipper with 24K gold plated handles. Double spring action for effortless cutting.",
    longDescription: "Experience professional-grade cuticle care with our 24K gold plated nipper. The 5mm precision jaw is hand-sharpened to surgical standards, ensuring clean cuts without tearing. Double spring action provides smooth, controlled operation with minimal hand fatigue. The luxurious gold finish makes this both a functional tool and a beautiful addition to any nail professional's collection.",
    specifications: [
      "Jaw: 5mm precision cutting edge",
      "Handle: 24K gold plated",
      "Length: 4.5 inches",
      "Spring: Double coil spring action",
      "Edge: Hand-sharpened surgical steel",
      "Box lock joint for stability"
    ],
    features: [
      "Ultra-precise 5mm cutting jaw",
      "24K gold plated finish",
      "Double spring for smooth action",
      "Professional salon grade",
      "Hand-sharpened edges",
      "Ergonomic grip"
    ],
    image: "https://images.unsplash.com/photo-1610992015762-45dca7656520?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQ4Njh8MHwxfHNlYXJjaHw1fHxtYW5pY3VyZXxlbnwwfHx8fDE3MzQ1Njk3NDB8MA&ixlib=rb-4.0.3&q=85",
    featured: true,
    rating: 4.8,
    reviews: 192,
    certifications: ["ISO 9001", "CE Marked"]
  },
  {
    id: 203,
    name: "Nail Scissors - Chrome Surgical Steel",
    category: "manicure-pedicure",
    price: 39.99,
    originalPrice: 59.99,
    currency: "USD",
    inStock: true,
    description: "Professional nail scissors with curved blades. Chrome finish for lasting beauty and easy sterilization.",
    longDescription: "Perfect your nail shaping with these professional-grade curved nail scissors. The curved blade design naturally follows nail contours for precise, even cutting. Mirror chrome finish provides both beauty and functionality - easy to clean and sterilize for professional salon use. Extra fine tips allow detailed work around cuticles.",
    specifications: [
      "Length: 3.5 inches",
      "Blade: Curved to match nail shape",
      "Material: Surgical stainless steel",
      "Finish: Mirror chrome",
      "Tips: Extra fine for precision",
      "Autoclavable for sterilization"
    ],
    features: [
      "Curved blade follows nail contour",
      "Mirror chrome finish",
      "Surgical steel precision",
      "Easy to sterilize and maintain",
      "Professional salon quality"
    ],
    image: "https://images.unsplash.com/photo-1632345031435-8727f6897d53?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQ4Njh8MHwxfHNlYXJjaHw3fHxtYW5pY3VyZXxlbnwwfHx8fDE3MzQ1Njk3NDB8MA&ixlib=rb-4.0.3&q=85",
    featured: true,
    rating: 4.7,
    reviews: 143,
    certifications: ["ISO 9001", "CE Marked"]
  },
  {
    id: 204,
    name: "Pedicure Tools Set - Gold & Silver Combo",
    category: "manicure-pedicure",
    price: 129.99,
    originalPrice: 179.99,
    currency: "USD",
    inStock: true,
    description: "Complete pedicure set with foot files, nail clippers, and callus removers. Gold and silver finish.",
    longDescription: "Achieve salon-perfect pedicures at home with this comprehensive 10-piece professional set. Features a stunning combination of gold and silver plating on premium stainless steel instruments. Includes specialized foot files, heavy-duty toenail clippers, callus removers, and precision grooming tools. All housed in a convenient zippered travel case.",
    specifications: [
      "Set: 10 pieces",
      "Finish: Gold & silver plated",
      "Includes: Foot files (2), nail clippers (2), pushers (2), callus remover, nail file, cuticle nipper, toe separator",
      "Material: Premium stainless steel",
      "Case: Zippered travel case with elastic holders",
      "Case size: 7\" x 4\" x 2\""
    ],
    features: [
      "Complete pedicure solution",
      "Dual gold & silver luxury finish",
      "Professional quality tools",
      "Travel-friendly zippered case",
      "Specialized foot care instruments"
    ],
    image: "https://images.unsplash.com/photo-1519415387722-a1c3bbef716c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQ4Njh8MHwxfHNlYXJjaHw5fHxwZWRpY3VyZXxlbnwwfHx8fDE3MzQ1Njk3NDB8MA&ixlib=rb-4.0.3&q=85",
    featured: false,
    rating: 4.6,
    reviews: 98,
    certifications: ["ISO 9001", "CE Marked"]
  },
  {
    id: 205,
    name: "Professional Tweezers Set - Precision Gold",
    category: "manicure-pedicure",
    price: 49.99,
    originalPrice: 74.99,
    currency: "USD",
    inStock: true,
    description: "Set of 4 professional tweezers in various tip styles. Gold plated with surgical precision.",
    longDescription: "Master precision grooming with this 4-piece professional tweezers set. Each tweezer features perfectly aligned tips hand-calibrated for optimal grip. The set includes slant tip (for general use), pointed tip (for ingrown hairs), flat tip (for splinters), and curved tip (for hard-to-reach areas). Luxurious gold plating over surgical-grade stainless steel.",
    specifications: [
      "Set: 4 tweezers (Slant, Point, Flat, Curved)",
      "Material: Surgical stainless steel",
      "Finish: 24K gold plated",
      "Length: 3.5\" - 4.5\"",
      "Tips: Hand-aligned for precision grip",
      "Includes protective caps"
    ],
    features: [
      "4 different specialized tip styles",
      "24K gold plated luxury",
      "Perfectly aligned tips",
      "Professional precision grip",
      "Protective tip caps included"
    ],
    image: "https://images.unsplash.com/photo-1596462502278-27bfdc403348?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQ4Njh8MHwxfHNlYXJjaHwxMHx8YmVhdXR5JTIwdG9vbHN8ZW58MHx8fHwxNzM0NTY5NzQwfDA&ixlib=rb-4.0.3&q=85",
    featured: false,
    rating: 4.8,
    reviews: 174,
    certifications: ["ISO 9001", "CE Marked"]
  },
  {
    id: 2,
    name: "Texturizing Shears - Chrome Elite",
    category: "salon-professional",
    description: "Professional texturizing scissors with chrome finish. 25-30 teeth for perfect blending and thinning.",
    specifications: [
      "Length: 6 inches",
      "Teeth: 25-30 teeth design",
      "Material: German stainless steel",
      "Finish: Mirror chrome plated",
      "Handle: Ergonomic crane design"
    ],
    features: [
      "Smooth texturizing action",
      "Chrome mirror finish",
      "Lightweight design",
      "Professional thinning"
    ],
    image: "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQ4Njh8MHwxfHNlYXJjaHw1fHxoYWlyJTIwc2Fsb258ZW58MHx8fHwxNzM0NTY5NzQwfDA&ixlib=rb-4.0.3&q=85",
    featured: true,
    certifications: ["ISO 9001", "CE Marked"]
  },
  {
    id: 3,
    name: "Barber Razor Scissors Combo Set",
    category: "salon-professional",
    description: "Complete professional cutting set with scissors, thinning shears, and styling comb in luxury gold case.",
    specifications: [
      "Set includes: Cutting scissors, Thinning shears, Comb, Case",
      "Material: Japanese steel",
      "Finish: Gold & Chrome combination",
      "Case: Premium leather storage",
      "Sizes: 5.5\" and 6\""
    ],
    features: [
      "Complete professional kit",
      "Luxury presentation case",
      "Gold plated accents",
      "Perfect for gifting"
    ],
    image: "https://images.unsplash.com/photo-1585747860715-2ba37e788b70?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQ4Njh8MHwxfHNlYXJjaHw3fHxoYWlyJTIwc2Fsb258ZW58MHx8fHwxNzM0NTY5NzQwfDA&ixlib=rb-4.0.3&q=85",
    featured: true,
    certifications: ["ISO 9001", "CE Marked"]
  },
  {
    id: 4,
    name: "Professional Hair Razor with Changeable Blades",
    category: "salon-professional",
    description: "Precision hair razor for detailed work, texturizing, and shaping. Chrome finish with replaceable blades.",
    specifications: [
      "Type: Straight edge razor",
      "Blade: Changeable single-edge",
      "Handle: Chrome plated brass",
      "Length: 6 inches closed",
      "Includes: 10 replacement blades"
    ],
    features: [
      "Precision cutting",
      "Replaceable blades",
      "Professional chrome finish",
      "Balanced weight"
    ],
    image: "https://images.unsplash.com/photo-1599351431202-1e0f0137899a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQ4Njh8MHwxfHNlYXJjaHw5fHxiYXJiZXJ8ZW58MHx8fHwxNzM0NTY5NzQwfDA&ixlib=rb-4.0.3&q=85",
    featured: false,
    certifications: ["ISO 9001", "CE Marked"]
  },

  // ========== BARBERSHOP ESSENTIALS CATEGORY ==========
  {
    id: 101,
    name: "Classic Straight Razor - Gold Damascus Edition",
    category: "barbershop-essentials",
    description: "Luxury straight razor with Damascus steel blade and 24K gold plated handle. The ultimate traditional shaving experience.",
    specifications: [
      "Blade: Damascus steel pattern",
      "Handle: 24K gold plated brass",
      "Blade width: 5/8 inch",
      "Edge: Hollow ground",
      "Includes: Luxury wooden box"
    ],
    features: [
      "Damascus steel beauty",
      "24K gold plated handle",
      "Professional barber quality",
      "Luxury presentation box"
    ],
    image: "https://images.unsplash.com/photo-1503951914875-452162b0f3f1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQ4Njh8MHwxfHNlYXJjaHwyfHxiYXJiZXJzaG9wfGVufDB8fHx8MTczNDU2OTc0MHww&ixlib=rb-4.0.3&q=85",
    featured: true,
    certifications: ["ISO 9001", "CE Marked"]
  },
  {
    id: 102,
    name: "Professional Shaving Kit - Chrome Elite Set",
    category: "barbershop-essentials",
    description: "Complete 7-piece chrome shaving set including razor, brush, bowl, stand, and grooming tools.",
    specifications: [
      "Set: 7 pieces complete",
      "Razor: Chrome safety razor",
      "Brush: Badger hair bristles",
      "Bowl: Chrome shaving bowl",
      "Stand: Premium chrome display stand",
      "Tools: Scissors, comb included"
    ],
    features: [
      "Complete shaving experience",
      "Mirror chrome finish",
      "Professional barbershop quality",
      "Elegant display stand"
    ],
    image: "https://images.unsplash.com/photo-1621605815971-fbc98d665033?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQ4Njh8MHwxfHNlYXJjaHw0fHxzaGF2aW5nfGVufDB8fHx8MTczNDU2OTc0MHww&ixlib=rb-4.0.3&q=85",
    featured: true,
    certifications: ["ISO 9001", "CE Marked"]
  },
  {
    id: 103,
    name: "Beard Trimming Scissors - Gold Titanium",
    category: "barbershop-essentials",
    description: "Precision beard and mustache scissors with gold titanium coating. Small, sharp, and perfectly balanced.",
    specifications: [
      "Length: 4.5 inches",
      "Material: Titanium coated steel",
      "Finish: Gold titanium",
      "Blade: Micro-serrated for grip",
      "Tips: Extra sharp pointed"
    ],
    features: [
      "Perfect for detail work",
      "Gold titanium coating",
      "Ultra-sharp tips",
      "Comfortable grip"
    ],
    image: "https://images.unsplash.com/photo-1599351431202-1e0f0137899a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQ4Njh8MHwxfHNlYXJjaHw2fHxiYXJiZXJ8ZW58MHx8fHwxNzM0NTY5NzQwfDA&ixlib=rb-4.0.3&q=85",
    featured: false,
    certifications: ["ISO 9001", "CE Marked"]
  },
  {
    id: 104,
    name: "Professional Barber Comb Set - Gold & Black",
    category: "barbershop-essentials",
    description: "Premium carbon fiber combs with gold accents. Heat resistant and anti-static for professional styling.",
    specifications: [
      "Set of 6 combs",
      "Material: Carbon fiber",
      "Accents: Gold plated spine",
      "Sizes: 6\", 7\", 8\", 9\"",
      "Features: Heat resistant, anti-static"
    ],
    features: [
      "Professional carbon fiber",
      "Gold luxury accents",
      "Heat resistant",
      "Complete size range"
    ],
    image: "https://images.unsplash.com/photo-1605497788044-5a32c7078486?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQ4Njh8MHwxfHNlYXJjaHw4fHxiYXJiZXJ8ZW58MHx8fHwxNzM0NTY5NzQwfDA&ixlib=rb-4.0.3&q=85",
    featured: false,
    certifications: ["ISO 9001", "CE Marked"]
  },

  // ========== MANICURE & PEDICURE CATEGORY ==========
  {
    id: 201,
    name: "Professional Manicure Set - Rose Gold Collection",
    category: "manicure-pedicure",
    description: "Luxury 15-piece rose gold plated manicure and pedicure set in premium leather case. Perfect for nail salons and spas.",
    specifications: [
      "Set: 15 premium instruments",
      "Finish: Rose gold plated",
      "Case: Genuine leather",
      "Includes: Nippers, files, pushers, scissors",
      "Material: Surgical grade stainless steel"
    ],
    features: [
      "Rose gold luxury finish",
      "Professional salon quality",
      "Complete nail care set",
      "Premium leather case"
    ],
    image: "https://images.unsplash.com/photo-1604654894610-df63bc536371?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQ4Njh8MHwxfHNlYXJjaHwzfHxtYW5pY3VyZXxlbnwwfHx8fDE3MzQ1Njk3NDB8MA&ixlib=rb-4.0.3&q=85",
    featured: true,
    certifications: ["ISO 9001", "CE Marked"]
  },
  {
    id: 202,
    name: "Cuticle Nipper - Gold Plated Professional",
    category: "manicure-pedicure",
    description: "Precision cuticle nipper with 24K gold plated handles. Double spring action for effortless cutting.",
    specifications: [
      "Jaw: 5mm precision cutting",
      "Handle: 24K gold plated",
      "Length: 4.5 inches",
      "Spring: Double coil spring",
      "Edge: Hand-sharpened surgical steel"
    ],
    features: [
      "Ultra-precise cutting",
      "24K gold finish",
      "Double spring action",
      "Professional grade"
    ],
    image: "https://images.unsplash.com/photo-1610992015762-45dca7656520?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQ4Njh8MHwxfHNlYXJjaHw1fHxtYW5pY3VyZXxlbnwwfHx8fDE3MzQ1Njk3NDB8MA&ixlib=rb-4.0.3&q=85",
    featured: true,
    certifications: ["ISO 9001", "CE Marked"]
  },
  {
    id: 203,
    name: "Nail Scissors - Chrome Surgical Steel",
    category: "manicure-pedicure",
    description: "Professional nail scissors with curved blades. Chrome finish for lasting beauty and easy sterilization.",
    specifications: [
      "Length: 3.5 inches",
      "Blade: Curved for nail shape",
      "Material: Surgical stainless steel",
      "Finish: Mirror chrome",
      "Tips: Extra fine cutting"
    ],
    features: [
      "Curved blade design",
      "Mirror chrome finish",
      "Surgical precision",
      "Easy to sterilize"
    ],
    image: "https://images.unsplash.com/photo-1632345031435-8727f6897d53?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQ4Njh8MHwxfHNlYXJjaHw3fHxtYW5pY3VyZXxlbnwwfHx8fDE3MzQ1Njk3NDB8MA&ixlib=rb-4.0.3&q=85",
    featured: true,
    certifications: ["ISO 9001", "CE Marked"]
  },
  {
    id: 204,
    name: "Pedicure Tools Set - Gold & Silver Combo",
    category: "manicure-pedicure",
    description: "Complete pedicure set with foot files, nail clippers, and callus removers. Gold and silver finish.",
    specifications: [
      "Set: 10 pieces",
      "Finish: Gold & silver plated",
      "Includes: Files, clippers, pushers, scrapers",
      "Material: Stainless steel",
      "Case: Zippered travel case"
    ],
    features: [
      "Complete pedicure solution",
      "Dual gold & silver finish",
      "Professional quality",
      "Travel-friendly case"
    ],
    image: "https://images.unsplash.com/photo-1519415387722-a1c3bbef716c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQ4Njh8MHwxfHNlYXJjaHw5fHxwZWRpY3VyZXxlbnwwfHx8fDE3MzQ1Njk3NDB8MA&ixlib=rb-4.0.3&q=85",
    featured: false,
    certifications: ["ISO 9001", "CE Marked"]
  },
  {
    id: 205,
    name: "Professional Tweezers Set - Precision Gold",
    category: "manicure-pedicure",
    description: "Set of 4 professional tweezers in various tip styles. Gold plated with surgical precision.",
    specifications: [
      "Set: 4 tweezers (Slant, Point, Flat, Curved)",
      "Material: Surgical steel",
      "Finish: 24K gold plated",
      "Length: 3.5\" - 4.5\"",
      "Tips: Hand-aligned precision"
    ],
    features: [
      "4 different tip styles",
      "Gold plated luxury",
      "Perfectly aligned tips",
      "Professional precision"
    ],
    image: "https://images.unsplash.com/photo-1596462502278-27bfdc403348?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQ4Njh8MHwxfHNlYXJjaHwxMHx8YmVhdXR5JTIwdG9vbHN8ZW58MHx8fHwxNzM0NTY5NzQwfDA&ixlib=rb-4.0.3&q=85",
    featured: false,
    certifications: ["ISO 9001", "CE Marked"]
  }
];

export const certifications = [
  {
    name: "ISO 9001:2015",
    description: "Quality Management System Certification"
  },
  {
    name: "CE Marked",
    description: "European Conformity for Beauty Instruments"
  },
  {
    name: "FDA Registered",
    description: "U.S. Food and Drug Administration Approved Facility"
  },
  {
    name: "GMP Certified",
    description: "Good Manufacturing Practices Compliant"
  }
];

export const testimonials = [
  {
    name: "Isabella Rodriguez",
    role: "Owner, Glamour Hair Salon NYC",
    content: "The gold-plated scissors are absolutely stunning! My clients love seeing the luxury tools, and the quality is exceptional. Best investment for my salon.",
    rating: 5
  },
  {
    name: "James Martinez",
    role: "Master Barber, Classic Cuts London",
    content: "Universa's chrome shaving kits are a game-changer. The traditional straight razors are perfectly balanced, and the finish is impeccable. Highly recommended!",
    rating: 5
  },
  {
    name: "Sophie Chen",
    role: "Nail Artist & Spa Owner",
    content: "The rose gold manicure set is not only beautiful but incredibly functional. Professional quality instruments that last. My nail technicians absolutely love them!",
    rating: 5
  }
];
